import React from 'react';
import propTypes from 'prop-types';
import './_blurb.scss';

const Blurb = props => {
    const { text, iconClass } = props;

    return (
        <div className='blurb'>
            <i className={`blurb-icon ${iconClass || 'blurb-icon__info'}`}></i>
            <p className={'blurb-text'}>{text}</p>
        </div>
    );
};

Blurb.propTypes = {
    text: propTypes.string.isRequired,
    iconClass: propTypes.string,
};

export default Blurb;
